import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlusCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M25.9 6.1a14 14 0 1 0 0 19.8 14 14 0 0 0 0-19.8M23.1 17H17v6a1 1 0 1 1-2 0v-6H9a1 1 0 0 1 0-2h6V9a1 1 0 0 1 2 0v6h6a1 1 0 0 1 0 2z" />
  </svg>
);
const ForwardRef = forwardRef(IconPlusCircleFilledSVG);
ForwardRef.displayName = "IconPlusCircleFilled";
export { ForwardRef as IconPlusCircleFilled };
